import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Time from "react-time-format";
import { change_Lang } from "../../../actions/Helper_action";
import { Search } from "react-feather";
import {
 Get_List_Rent_Contracts,
 Rent_Delete_Status,
 View_Rent_Contract,
} from "../../../actions_agent/Invoice_action";
import { Button, Drawer, Input, Modal, Switch, Tooltip } from "antd";
import Swal from "sweetalert2";
import { isMobile } from "react-device-detect";
import PropertyesList from "../../Propertys_Agent/PropertyesList";
import CustomDataTable from "../../../components/HOC/CustomDataTable";
import { FilterComponent } from "../../../components/HOC/FilterComponent";
import {
 FaBan,
 FaCoins,
 FaEye,
 FaHandHoldingUsd,
 FaPrint,
} from "react-icons/fa";
import EditContractRentList from "./EditContractRentList";
const ListRentContract = () => {
 const dispatch = useDispatch();
 const user = useSelector((state) => state.AuthReducer.user);
 const [hideDirector, setHideDirector] = useState(false);
 useEffect(() => {
  if (user && user.v_contract !== false) {
   setHideDirector(false);
  } else {
   setHideDirector(true);
  }
  dispatch(Get_List_Rent_Contracts());
 }, []);
 const lang = useSelector((state) => state.HelperReducer.lang);
 const rent_contracts = useSelector(
  (state) => state.Invoice_Reducer.rent_contracts
 );
 const [search, setsearch] = useState("");
 const [select_rent, setselect_rent] = useState("");
 const [visible, setvisible] = useState(false);
 const [showModal_, setShowModal] = useState(false);
 const toggleModal = () => {
  setShowModal(!showModal_);
 };
 const initialColumns = React.useMemo(() => {
  return [
   {
    name: dispatch(change_Lang("id")),
    selector: "id",
    center: true,
    compat: true,
    width: "70px",
    visibility: true,
   },
   {
    name: dispatch(change_Lang("Code Number")),
    selector: "s_num",
    center: true,
    compact: true,
    width: "80px",
    visibility: true,
   },
   {
    name: dispatch(change_Lang("Code Letter")),
    selector: "s_letter",
    center: true,
    compact: true,
    width: "80px",
    visibility: true,
   },
   {
    name: dispatch(change_Lang("first_rule_place")),
    selector: "place",
    center: true,
    compact: true,
    width: "120px",
    visibility: true,
   },
   {
    name: dispatch(change_Lang("Property Detail")),
    selector: "property_detail",
    center: true,
    compact: true,
    visibility: true,
    width: "140px",
   },
   {
    name: dispatch(change_Lang("First side (property owner)")),
    selector: "firstName",
    center: true,
    compat: true,
    visibility: true,
    width: "140px",
   },
   {
    name: dispatch(change_Lang("Second side (tenant)")),
    selector: "secondName",
    center: true,
    compat: true,
    visibility: true,
    width: "140px",
   },
   {
    name: dispatch(change_Lang("monthly payments")),
    selector: "lastPrice",
    center: true,
    compat: true,
    className: "fk",
    width: "100px",
    visibility: true,
   },
   {
    name: dispatch(change_Lang("date")),
    selector: "date",
    center: true,
    compat: true,
    width: "120px",
    visibility: true,
   },
   {
    name: dispatch(change_Lang("Action")),
    selector: "action",
    center: true,
    compact: true,
    omit: hideDirector,
    visibility: true,
    width: "180px",
   },
  ];
 }, [hideDirector]);
 const [columns, setColumns] = useState(initialColumns);
 const handleColumnToggle = (columnKey) => {
  setColumns((prevColumns) =>
   prevColumns.map((column) =>
    column.selector === columnKey
     ? { ...column, visibility: !column.visibility }
     : column
   )
  );
 };
 const showDrawer = () => {
  setvisible(true);
 };
 const onClose = () => {
  setvisible(false);
 };
 const handleChange_Property = (value) => {
  setselect_rent(value);
 };
 const Rent_getPrint = () => {
  window.setTimeout("window.print()", 2000);
 };
 const onDeleteRent_Contract = (id, status) => {
  return Swal.fire({
   title: dispatch(change_Lang("Are you sure")),
   text: dispatch(change_Lang("You won't be able to delete this!")),
   icon: "warning",
   showCancelButton: true,
   confirmButtonColor: "#d33",
   cancelButtonColor: "#3085d6",
   confirmButtonText: dispatch(change_Lang("Yes, delete it")),
   cancelButtonText: dispatch(change_Lang("cancel")),
   confirmButtonClass: "fk",
   cancelButtonClass: "fk",
   customClass: {
    title: "fk",
    content: "fk",
   },
  }).then((result) => {
   if (result.isConfirmed) {
    dispatch(Rent_Delete_Status(id, status));
    Swal.fire({
     title: dispatch(change_Lang("Delete")),
     text: dispatch(change_Lang("Your work has been successfully completed")),
     icon: "success",
     customClass: {
      title: "fk",
      content: "fk",
     },
     timer: 1000,
    });
   }
  });
 };
 const datas = rent_contracts
  .filter((data) => {
   return FilterComponent({
    main_state: search,
    secondary_state: select_rent,
    element: data,
    change_able:
     data.tenantId &&
     data.tenantId.secondname.toLowerCase().startsWith(search.toLowerCase()),
   });
  })
  .map((el, i) => {
   return {
    id: el.InvoiceNO,
    branchId: (
     <span className={`${lang === "en" ? "" : "fk"}`}>
      {el.branchId && el.branchId.name}
     </span>
    ),
    firstName: (
     <div className={`${lang === "en" ? "text-center" : "text-center fk"}`}>
      {el.firstname}
      <br />
      {el.phone1}
     </div>
    ),
    secondName: (
     <div className={`${lang === "en" ? "text-center" : "text-center fk"}`}>
      {el.tenantId && el.tenantId.secondname}
      <br />
      {el.tenantId && el.tenantId.phone2}
     </div>
    ),
    s_num: <span className={`${lang === "en" ? "" : "fk"}`}>{el.s_code}</span>,
    s_letter: (
     <span className={`${lang === "en" ? "" : "fk"}`}>{el.s_letter}</span>
    ),
    Area: <span className={`${lang === "en" ? "" : "fk"}`}>{el.Area}</span>,
    phone: el.Phone,
    lastPrice: (
     <NumberFormat
      displayType="text"
      thousandSeparator={true}
      value={el.paymentmonth}
      className={`${lang === "en" ? "" : "fk"}`}
      prefix={`${el.currency !== "dolar" ? "ID" : "$"}`}
     />
    ),
    date: (
     <Time
      value={el.createdAt}
      format="YYYY-MM-DD"
      style={{ color: "black" }}
      className={`${lang === "en" ? "" : "fk"}`}
     />
    ),
    property_detail: (
     <>
      <span className={`${lang === "en" ? "" : "fk"}`}>
       {el.available_id && dispatch(change_Lang(el.available_id.Property))}
      </span>
      &nbsp;-&nbsp;
      <span className={`${lang === "en" ? "" : "fk"}`}>
       {el.available_id && el.available_id.NOoFProperty}
      </span>
     </>
    ),
    place: (
     <span
      className={`${lang === "en" ? "" : "fk"}`}
      style={{ fontSize: "14px" }}
     >
      {lang === "en"
       ? el.available_id && el.available_id.Place_en
       : lang === "arb"
       ? el.available_id && el.available_id.Place_ar
       : el.available_id && el.available_id.Place_ku}
     </span>
    ),
    action: (
     <>
      <Tooltip title="View">
       <Button
        style={{ background: "#efefed", color: "#295a68" }}
        shape="circle"
        onClick={() => {
         dispatch(View_Rent_Contract(el._id, el.InvoiceNO));
         showDrawer();
        }}
        icon={
         <FaEye
          style={{
           cursor: "pointer",
          }}
          className="text-center mt-1"
         />
        }
       />
      </Tooltip>
      &nbsp;
      <Tooltip title="Print">
       <Link to={`/print_Rent_View/${el._id}/${rent_contracts.length - i}`}>
        <Button
         style={{ background: "#efefed", color: "#295a68" }}
         shape="circle"
         onClick={() => {
          dispatch(View_Rent_Contract(el._id, rent_contracts.length - i));
          Rent_getPrint();
         }}
         icon={
          <FaPrint
           style={{
            cursor: "pointer",
           }}
           className="text-center mt-1"
          />
         }
        />
       </Link>
      </Tooltip>
      &nbsp;
      <Tooltip title={dispatch(change_Lang("Repayment bills"))} className="fk">
       <Link to={`/take_money`}>
        <Button
         style={{ background: "#efefed", color: "#295a68" }}
         shape="circle"
         onClick={() => dispatch(View_Rent_Contract(el._id, el.InvoiceNO))}
         icon={
          <FaCoins
           style={{
            cursor: "pointer",
           }}
           className="text-center mt-1"
          />
         }
        />
       </Link>
      </Tooltip>
      &nbsp;
      <Tooltip title={dispatch(change_Lang("Payment bills"))} className="fk">
       <Link to={`/pswlay_paradan`}>
        <Button
         style={{ background: "#efefed", color: "#295a68" }}
         shape="circle"
         onClick={() => dispatch(View_Rent_Contract(el._id, el.InvoiceNO))}
         icon={
          <FaHandHoldingUsd
           style={{
            cursor: "pointer",
           }}
           className="text-center mt-1"
          />
         }
        />
       </Link>
      </Tooltip>
      &nbsp;
      {user.d_contract !== false ? (
       <Tooltip title="Delete">
        <Button
         style={{ background: "#efefed", color: "#295a68" }}
         shape="circle"
         onClick={() => onDeleteRent_Contract(el._id, "delete")}
         icon={
          <FaBan
           style={{
            cursor: "pointer",
           }}
           className="text-center mt-1"
          />
         }
        />
       </Tooltip>
      ) : (
       ""
      )}
     </>
    ),
   };
  });
 return (
  <>
   <Fragment>
    <Breadcrumb
     title={dispatch(change_Lang("Rent Contracts"))}
     parent={dispatch(change_Lang("Contract List"))}
    />
    <div
     className={`${lang === "en" ? "container-fluid" : "container-fluid fk"}`}
    >
     <div className="row">
      <div className="col-xs-12 col-sm-12 ">
       <div className={isMobile ? "" : "card"}>
        <div className="row ">
         <div
          className={
           isMobile
            ? "col-md-4 d-flex justify-content-center"
            : "col-md-3 card-header d-flex justify-content-start"
          }
         >
          <PropertyesList
           onChangeProperty={handleChange_Property}
           valueOption={select_rent}
           size="middle"
           style={{
            fontSize: "16px",
            borderBottomColor: "#295a68",
           }}
          />
         </div>
         <div className={isMobile ? "col-md-6" : "col-md-6 card-header"}>
          <div className=" text-center mt-2">
           <h4 style={{ fontWeight: "bold", color: "#295a68" }}>
            {dispatch(change_Lang("Rent Contracts"))}
           </h4>
          </div>
         </div>
         <div
          className={
           isMobile
            ? "col-md-3 d-flex justify-content-center form-inline"
            : "col-md-3 d-flex justify-content-start form-inline"
          }
         >
          <Input
           type="text"
           name="search"
           value={search}
           onChange={(e) => setsearch(e.target.value)}
           size="middle"
           placeholder={dispatch(change_Lang("Search"))}
           autoComplete="off"
           style={{ width: "180px" }}
           prefix={<Search color="lightgray" />}
          />
          &nbsp;&nbsp;
          <span className="">
           <button
            onClick={toggleModal}
            className="btn m-auto btn-sm p-1 exp_btn "
           >
            <i className="fa-solid fa-bars"></i>
           </button>
          </span>
         </div>
        </div>
        <div className="row table-responsive">
         <CustomDataTable
          columns={columns.filter((column) => column.visibility)}
          data={datas}
         />
        </div>
       </div>
      </div>
     </div>
    </div>
    <Drawer onClose={onClose} open={visible} width={isMobile ? "" : "990px"}>
     <EditContractRentList onClose={onClose} />
    </Drawer>
    <Modal
     title="Select Columns"
     open={showModal_}
     onCancel={toggleModal}
     width={430}
     footer={[
      <Button key="close" onClick={toggleModal}>
       Close
      </Button>,
     ]}
    >
     {columns.map((column) => (
      <div
       className="row d-flex justify-content-center"
       key={column.selector}
       style={{ marginBottom: 16, textAlign: "justify" }}
      >
       <span className="col-5 fk" style={{ marginLeft: 8, fontSize: "15px" }}>
        {column.name}
       </span>
       <Switch
        checked={column.visibility}
        style={{
         background: column.visibility ? "#5172dd" : "#babbba",
        }}
        className="col-1"
        onChange={() => handleColumnToggle(column.selector)}
       />
      </div>
     ))}
    </Modal>
   </Fragment>
  </>
 );
};

export default ListRentContract;
